<template>
    <div class="main-body">
        <div class="header">文件上传</div>
        <div class="out">

            <div class="search2">

              <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="clear: both;"></div>
            </div>


            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                      :height="th" border>

              <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>

              <el-table-column prop="idCard" label="身份证" width="200"></el-table-column>

              <el-table-column prop="serviceStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">默认</span>
                  <span v-if="scope.row.status == 1">正常</span>
                  <span v-if="scope.row.status == 2">禁用</span>
                </template>
              </el-table-column>


              <el-table-column prop="createTime" label="创建时间" width="180">
                <template slot-scope="scope">
                  <p>{{scope.row.createTime | timefilters }}</p>
                </template>
              </el-table-column>


              <el-table-column fixed="right" label="操作" width="140">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>
                  </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
            v-bind:arr_business="arr_business" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit"
              v-bind:arr_business="arr_business" v-on:getList="getList"></Edit>


    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getGovernmentCode, getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";


    export default {
        name: "Role",
      //注册局部过滤器
      filters: {
        timefilters(val) {
          if (val == null || val == "") {
            return "";
          } else {
            let d = new Date(val);   //val 为表格内取到的后台时间
            let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
            let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
          }
        }
      },
        data() {
            return {

                tableLoading: false,

                showModalAdd: false,
                showModalEdit: false,

                tableData: [],
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,


                th: 0,


            }
        },
        components: {
            Add, Edit
        },
        created() {

            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {


            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
          closeAdd: function () {
            this.showModalAdd = !this.showModalAdd;
          },

          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },


            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
          getList(isSearch){
            if(isSearch)this.currentPage=1
            var _this=this
            this.tableLoading=true

            this.$axios({
              method: 'post',
              url: this.$shopUrl + "Serve/GovPageBus",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                staffCode: getStaffCode(),
                businessCode:this.businessCode,
                name: '',
                status: -1,
                pageIndex: this.currentPage,
                pageSize: this.pageSize,
              }
            }).then((response) => {
              _this.tableLoading=false
              if (response.data.error == 0) {
                this.tableData = response.data.data.pageInfo.list;
                this.totalItems = response.data.data.pageInfo.total;
              }
            }).catch(function (error) {
              _this.tableLoading=false
              console.log(error);
            });
          },



        }
    }
</script>

<style scoped>

</style>
